import type { Product, Certification, TabSection } from './eto-app';
import CustomSelect from './custom-select';

function CertificationSection({ componentName, componentsLoading, error, certifications, components, tab, setActiveSubsection, euImporterAddress, euRepresentativeAddress, i18n }: {
    componentName: string;
    componentsLoading: boolean;
    error: string | null;
    certifications: Certification[];
    components: Product[];
    tab: TabSection | undefined;
    setActiveSubsection: (tabName: string, subtabName: string | null, subsectionName: string) => void;
    euImporterAddress: string | null;
    euRepresentativeAddress: string | null;
    i18n: (key: string) => string;
}) {
    const librarySearchTerm = components.filter((component) => component.id).length > 0 ? components.map((component) => component.id).join(',') : new URLSearchParams(window.location.search).get('.S') || '';
    return (
        <>
            {componentsLoading &&
                <tbody>
                    {new Array(6).fill(0).map((_, index) => (
                        <tr key={index} className={`${componentName}__table-row ${componentName}__table-row-skeleton`}>
                            <th className={`${componentName}__table-cell-skeleton`}>
                                <div className={`${componentName}__table-cell-skeleton-content ${componentName}__loading-animation`}></div>
                            </th>
                            <td className={`${componentName}__table-cell-skeleton`}>
                                <div className={`${componentName}__table-cell-skeleton-content ${componentName}__loading-animation`}></div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            }
            {!componentsLoading && !error && tab && certifications &&
                <>
                    {/* {components.filter((component) => component.hasCertifications).length > 0 && (
                        <div className={`${componentName}__spec-filter`}>
                            <CustomSelect
                                componentName={componentName}
                                className={`${componentName}__spec-filter-select`}
                                ariaLabel={i18n('Filter by component')}
                                value={tab.activeSection || 'All'}
                                options={[
                                    { value: 'All', label: i18n('All Components') },
                                    ...components.filter((component) => component.hasCertifications).map((component) => ({
                                        value: component.id,
                                        label: component.id,
                                    })),
                                ]}
                                onChange={(value) => {
                                    setActiveSubsection(tab.name, null, value);
                                }}
                                i18n={i18n}
                            />
                        </div>
                    )} */}
                    {(certifications.filter((certification) => certification.componentIds.includes(tab.activeSection) || certification.componentIds.includes('All') || (tab.activeSection === 'All')).filter((certification) => certification.icon).length > 0) && (
                        <div className={`${componentName}__certification-icons`}>
                            {certifications.filter((certification) => (certification.componentIds.includes(tab.activeSection) || certification.componentIds.includes('All') || (tab.activeSection === 'All'))).filter((certification) => certification.icon).map((certification) => (
                                certification.link ? (
                                    <a href={certification.link}>
                                        <img src={certification.icon} alt={certification.name} />
                                    </a>
                                ) : (
                                    <img src={certification.icon} alt={certification.name} />
                                )
                            ))}
                        </div>
                    )}
                    {(tab.activeSection === 'All' || certifications.filter((certification) => (certification.componentIds.includes(tab.activeSection) || certification.componentIds.includes('All'))).length > 0) && (
                        <ul className={`${componentName}__certification-list`}>
                            {certifications.filter((certification) => (certification.componentIds.includes(tab.activeSection) || certification.componentIds.includes('All') || (tab.activeSection === 'All'))).map((certification) => (
                                <li key={certification.name}>
                                    {certification.link ? (
                                        <a href={certification.link}>
                                            <span className={`${componentName}__certification-name`}>
                                                {certification.name}
                                            </span>
                                        </a>
                                    ) : (
                                        <span className={`${componentName}__certification-name`}>
                                            {certification.name}
                                        </span>
                                    )}
                                </li>
                            ))}
                        </ul>
                    )}
                    <div className={`${componentName}__certification-more-info`}>
                        <div className={`${componentName}__certification-more-info-header`}>
                            {i18n('Looking for more certification documents?')}
                        </div>
                        <div className={`${componentName}__certification-more-info-text`}>
                            {i18n('Explore certifications for this product and more in our comprehensive Literature Library.')}
                        </div>
                        <a className={`${componentName}__certification-more-info-link`} href={`https://www.rockwellautomation.com/search/ra-en-US;keyword=${librarySearchTerm};activeTab=Literature;`}>
                            {i18n('Search the Literature Library')}
                            <span className={`${componentName}__certification-more-info-link-icon`} aria-hidden="true">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" aria-hidden="true">    <path d="M12.446 7.514l5.474 8.88-5.455 8.063a.8.8 0 1 0 1.325.897l5.745-8.491a.799.799 0 0 0 .018-.868l-5.745-9.32a.8.8 0 0 0-1.362.839z"></path></svg>
                            </span>
                        </a>
                    </div>
                    {(euImporterAddress || euRepresentativeAddress) && (
                        <div className={`${componentName}__table-section`}>
                            <div className={`${componentName}__table-section-header`}>
                                <span className={`${componentName}__table-section-name`}>{i18n('Regulatory Information')}</span>
                            </div>
                            <table className={`${componentName}__table`}>
                                <tbody>
                                    {euImporterAddress && <tr className={`${componentName}__table-row`}>
                                        <th className={`${componentName}__table-cell`}>{i18n('EU Importer Address')}</th>
                                        <td className={`${componentName}__table-cell`} dangerouslySetInnerHTML={{ __html: euImporterAddress }}></td>
                                    </tr>}
                                    {euRepresentativeAddress && <tr className={`${componentName}__table-row`}>
                                        <th className={`${componentName}__table-cell`}>{i18n('EU Authorized Representative Address')}</th>
                                        <td className={`${componentName}__table-cell `} dangerouslySetInnerHTML={{ __html: euRepresentativeAddress }}></td>
                                    </tr>}
                                </tbody>
                            </table>
                        </div>
                    )}
                    {(euImporterAddress || euRepresentativeAddress) && components.filter((component) => component.hasCertifications).length > 0 && (
                        <div className={`${componentName}__table-section`}>
                            <div className={`${componentName}__table-section-header`}>
                                <span className={`${componentName}__table-section-name`}>{i18n('Component Regulatory Information')}</span>
                            </div>
                            <table className={`${componentName}__table`}>
                                <tbody>
                                    {euImporterAddress && <tr className={`${componentName}__table-row`}>
                                        <th className={`${componentName}__table-cell`}>{i18n('EU Importer Address')}</th>
                                        <td className={`${componentName}__table-cell`} dangerouslySetInnerHTML={{ __html: euImporterAddress }}></td>
                                    </tr>}
                                    {euRepresentativeAddress && <tr className={`${componentName}__table-row`}>
                                        <th className={`${componentName}__table-cell`}>{i18n('EU Authorized Representative Address')}</th>
                                        <td className={`${componentName}__table-cell `} dangerouslySetInnerHTML={{ __html: euRepresentativeAddress }}></td>
                                    </tr>}
                                </tbody>
                            </table>
                        </div>
                    )}
                </>
            }
        </>
    );
}

export default CertificationSection;